import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'

import './index.css'
import 'react-flexbox-grid/dist/react-flexbox-grid.css'

import store from './store'
import App from './containers/App/'

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>
  , document.getElementById('adene-merchants')
)



// WEBPACK FOOTER //
// ./src/index.js